<template>
  <div class="inline-flex px-4 py-1 text-xs font-semibold leading-none rounded-full" :class="[background, color, { 'lg:pt-0 lg:text-xl lg:leading-snug': large }]">
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  background: string
  color: string
  large?: boolean
}

defineProps<Props>()
</script>
